import React, {Fragment} from 'react';
import {Skeleton} from '@mui/material';
import {type Column, type RowData} from '@tanstack/react-table';
import {type ColumnPinningState} from '@tanstack/table-core';
import {styled} from '@netx/core-components/Theme';
import {TableCell} from './TableCell';
import {TableRow, type TableRowProps} from './TableRow';

const TableBodyRowLoadingRoot = styled(TableRow)(({theme}) => ({}));

export interface TableBodyRowLoadingProps<TData extends RowData>
	extends TableRowProps<TData> {
	columns: Column<TData, unknown>[];
	index: number;
	lastSizeableColumnIndex?: number;
	leftLeafColumnWidths?: number[];
	pinnedColumns?: ColumnPinningState;
	rightLeafColumnWidths?: number[];
}

export const TableBodyRowLoadingPrimitive = <TData extends RowData>({
	columns,
	lastSizeableColumnIndex,
	leftLeafColumnWidths,
	pinnedColumns,
	rightLeafColumnWidths,
	...props
}: TableBodyRowLoadingProps<TData>) => {
	return (
		<TableBodyRowLoadingRoot data-loding={true} {...props}>
			{columns.map((column, index) => (
				<Fragment key={index}>
					{index === lastSizeableColumnIndex && (
						<div style={{flex: '1 1 auto'}} />
					)}
					<TableCell
						index={index}
						leftLeafColumnWidths={leftLeafColumnWidths}
						pinnedColumns={pinnedColumns}
						rightLeafColumnWidths={rightLeafColumnWidths}
						columnId={column.id}
						width={column.getSize()}
					>
						<Skeleton variant="text" width="100%" animation={false} />
					</TableCell>
				</Fragment>
			))}
		</TableBodyRowLoadingRoot>
	);
};

export const TableBodyRowLoading = TableBodyRowLoadingPrimitive;

export default TableBodyRowLoading;
